import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, goBack } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import { Toast } from 'antd-mobile'
import messages from 'languages/messages'
import { intl } from 'utils'

// ------------------------------------
// Constants
// ------------------------------------
export const BANK_CARD_ADD_BANK_ACCOUNT = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  QUERY_IBAN_REQUEST: null,
  QUERY_IBAN_SUCCESS: null,
  RESET_IBAN_INF: null,
}, 'BANK_CARD_ADD_BANK_ACCOUNT')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/personal/card/bindCard',
        requestAction: BANK_CARD_ADD_BANK_ACCOUNT.INIT_REQUEST,
        successAction: BANK_CARD_ADD_BANK_ACCOUNT.INIT_SUCCESS,
        success: function(result) {
          Toast.info(intl.formatMessage(messages.settingProceededSuccessfully), 2, () =>
            dispatch(goBack())
          )
        },
      })
    )
  }
}

export function queryIban(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/personal/common/analyzeIban',
        requestAction: BANK_CARD_ADD_BANK_ACCOUNT.QUERY_IBAN_REQUEST,
        successAction: BANK_CARD_ADD_BANK_ACCOUNT.QUERY_IBAN_SUCCESS,
        success: function(result) {},
        error: function() {
          dispatch({
            type: BANK_CARD_ADD_BANK_ACCOUNT.RESET_IBAN_INF,
            payload: {
              bankCode: '',
              bankName: '',
            },
          })
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BANK_CARD_ADD_BANK_ACCOUNT.INIT_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [BANK_CARD_ADD_BANK_ACCOUNT.INIT_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [BANK_CARD_ADD_BANK_ACCOUNT.QUERY_IBAN_REQUEST]: (state, action) =>
    Object.assign({}, state, action.payload),
  [BANK_CARD_ADD_BANK_ACCOUNT.QUERY_IBAN_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [BANK_CARD_ADD_BANK_ACCOUNT.RESET_IBAN_INF]: (state, action) =>
    Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'bankCardAddBankAccount',
    reducerMap: {
      bankCardAddBankAccountState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
